import React, { Component } from 'react';
import styles from './styles';
import { css } from 'aphrodite';
import { Title } from '../../library';

class Header extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        const { image, title } = this.props;
        return (
            <div className={css(styles.header)}>
                {image &&
                <figure className={css(styles.figure)}>
                    <img className={css(styles.image)} src={image} alt="header" />
                </figure>
                }
                {title &&
                <Title style={styles.title}>{title}</Title>
                }
            </div>
        );
    }
}

export default Header;
